<template>
  <FormFieldWrapper :data="data">
    <div class="yesno-container">
      <VARadioGroup
        :modelValue="modelValue"
        @update:modelValue="handleChange"
        color="dark-blue"
        size="default"
      >
        <VARadio label="yes">Yes</VARadio>
        <VARadio label="no">No</VARadio>
      </VARadioGroup>
    </div>
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'YesNo',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleChange(value) {
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style scoped>
.yesno-container {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}
:deep(.va-radio-group) {
  flex-direction: row !important;
  justify-content: center;
  width: 100%;
}
:deep(.va-radio-group .va-radio) {
  min-width: fit-content;
  width: 33%;
  justify-content: center;
}
</style>
